import { render, staticRenderFns } from "./FavoriteLink.vue?vue&type=template&id=2f5245aa&"
import script from "./FavoriteLink.vue?vue&type=script&lang=js&"
export * from "./FavoriteLink.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteLink.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports